import React from 'react'

function HasPendingWorkflowToggle({ params, setParams }) {
  const checked = params.has_pending_workflow === 'true'

  const handleChange = (e) => {
    const newChecked = e.target.checked
    const newValue = newChecked ? 'true' : ''

    setParams({
      ...params,
      has_pending_workflow: newValue
    })
  }

  return (
    <div className="form-check form-switch mt-1">
      <input
        className="form-check-input"
        type="checkbox"
        id="has-pending-workflow"
        checked={checked}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor="has-pending-workflow">
        Has Pending Workflow
      </label>
    </div>
  )
}

export default HasPendingWorkflowToggle
